module.exports = __webpack_public_path__ + "static/media/feed_empty.0511b310.png";